import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function ReceiveAcceptanceList(props) {
  const Config = {
    purchase: {
      apiPath: '/purchaseAccp/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/receive/acceptance/detail',
      searchBarPlaceholder: '供应商名称/编码、验收单号、物料名称/编码/规格',
      orderProperty: 'createTime',
      tabs: ['全部', '待发布', '待审批'],
      tabConfig: [
        undefined, //全部
        0, //待发布
        1 //待审批
      ],
      arrEnumField: [
        {
          mainKey: 'B02_Po_Assets_Acceptance_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    decimalPlace,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setListField,
    setTotalField,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  //扩展搜索参数
  self.beforeSearch = async function () {
    if (self.isPurchase) {
      self.searchQueries = {
        status: config.tabConfig[currentTab]
      };
    }
  };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.accpXkNo}`}
                      key={item.id}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.accpXkNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('paas', item.status)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>供应商</label>
                          <div>
                            {item.innerVendorName}({item.innerVendorCode})
                          </div>
                        </li>
                        <li>
                          <label>验收日期</label>
                          <div>{formatDate(item.accpTime, 'YYYY-MM-DD')}</div>
                        </li>
                        <li>
                          <label>建单人</label>
                          <div>{item.employeeName}</div>
                        </li>
                        <li>
                          <label>采购单号</label>
                          <div>{item.poErpNo}</div>
                        </li>
                        <li>
                          <label>验收数量</label>
                          {formatNumber(item.totalCount, item.QTY)}
                        </li>
                        <li>
                          <label>验收金额</label>
                          {item.isContainTax === 0
                            ? formatNumber(item.accpTotal, item.AMOUNT)
                            : formatNumber(item.accpTaxTotal, item.AMOUNT)}
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

ReceiveAcceptanceList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(ReceiveAcceptanceList);
